import { createFileRoute } from '@tanstack/react-router'
import { AssemblyInfo } from 'pages/inventoryManagement/AssemblyInfo'
import { z } from 'zod'

const assemblySearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
})

export const Route = createFileRoute('/assembly/$assemblyID')({
  component: AssemblyInfo,
  staticData: {
    title: 'Assembly',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
  validateSearch: assemblySearchParams,
})
